import { render, staticRenderFns } from "./detail_score.vue?vue&type=template&id=2480c0de&scoped=true&"
import script from "./detail_score.vue?vue&type=script&lang=js&"
export * from "./detail_score.vue?vue&type=script&lang=js&"
import style0 from "./detail_score.vue?vue&type=style&index=0&id=2480c0de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480c0de",
  null
  
)

export default component.exports